
<template>
  <div class="baoxiuBox">
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
      <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" type="text" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="captcha" v-if="captchaValidate">
          <el-input v-model="ruleForm.captcha" type="text" style="width: 60%" placeholder="验证码"></el-input>
          <button :disabled="disabled" @click="getYzm" type="button" class="yzmBtn" style="width: 38%;">{{msg}}</button>
        </el-form-item>
        <el-form-item label="投诉/建议" prop="taskType">
          <el-select v-model="ruleForm.taskType" clearable placeholder="请选择类型">
            <el-option
              v-for="item in taskOption"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictLabel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="ruleForm.taskContent" type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item>
         <el-form-item label="上传图片">
          <div class="file" >
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getFile"
            />请上传图片
          </div>
        </el-form-item>
      <div v-for="(item,ind) in imgList" :key="ind" class="imgDiv">
        <b @click="deleteImg(ind)" class="el-icon-error error_icon"></b>
        <img class="imgItemRead avatar"   :src="item" alt="">
      </div>
      </el-form>

    </el-card>
    <button style="width:100%" class="btn_bind" type="primary" @click="submitForm('ruleForm')">立 即 提 交</button>
  </div>
</template>

<script>
import {  baoxiu,getCaptcha } from "@/api";
export default {
  name:'tousujianyi',
  data() {
    return {
      ruleForm: {

      },
      rules: {
        taskType: [
          { required: true, message: "请选择报修类型", trigger: "change" },
        ],
         phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
        ],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ]
      },
      taskOption: [
        {dictLabel:'投诉',dictValue:'投诉'},
        {dictLabel:'建议',dictValue:'建议'}
      ],
      value: "",
      maxtime: 60, //一个小时，按秒计算，自己调整!
      timer: null,
      msg: '获取验证码',
      disabled: false,
      captchaValidate: true,
      imgList: [],
      fileList: []
    };
  },
  mounted() {
    // this.getTaskType();
    this.captchaValidate = JSON.parse(sessionStorage.getItem('roles'))&&JSON.parse(sessionStorage.getItem('roles')).captchaValidate
    this.ruleForm.openId = sessionStorage.getItem('thirdId')
    this.ruleForm.userCode = this.$route.query.code
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var formdata = new FormData();
          for (let k in this.ruleForm) {
            formdata.append(k, this.ruleForm[k]);
          }
          baoxiu(formdata).then(res=>{
            this.$toast('报修成功')
            this.$router.go(-1)
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getYzm() {
      var reg_tel = /^(1)\d{10}$/;
      if(!reg_tel.test(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号码')
        return
      }
      let params = {
        sysType: 1,
        phone: this.ruleForm.phone,
      }
      getCaptcha(params).then(res=>{
        if(res.code=='0000') {
          this.maxtime = 60
          this.disabled = true
          this.timer = setInterval(() => {
            this.CountDown()
          }, 1000)
        }
      })
    },
    getFile(e) {
      console.log('change',e)
      let file = e.target.files[0]
      this.fileList.push(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload =  (e) => {    //成功读取文件
        this.imgList.push(e.target.result)
      };
    },
    deleteImg(ind) {
      this.imgList.splice(ind,1);
      this.fileList.splice(ind,1)
    },
    CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime
          this.msg =   + seconds + "s"+'后获取';
          --this.maxtime;
        } else{
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      },
    /**
     * 获取类型
     */
    // getTaskType() {
    //   getTaskType(sessionStorage.getItem("companyCode")).then((res) => {
    //     this.taskOption = res.data;
    //     console.log(res.data)
    //   });
    // },

  },
};
</script>
<style  scoped>
.uploader-file {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader-file:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 178px;
  display: block;
  margin-top: 25px;
}

.file {
  width: 92%;
  height: 30px;
  position: relative;
  display: inline-block;
  background: #FBFDFF;
  border: 1px  #C0CCDA dashed;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #1E88C7;
  text-decoration: none;
  text-indent: 0;
  text-align: center;
  line-height: 30px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: #FBFDFF;
  border-color: #AADFFD;
  color: #004974;
  text-decoration: none;
}
.imgDiv{
  position: relative;
}
.error_icon{
  position: absolute;
  font-size: 25px;
  right: -15px;
  top:-18px;
  z-index: 999999;
  color: #f00;
}
.baoxiuBox {
  /* background: #fff; */
  padding: 3% 3%;
  min-height: 90%;
}
.baoxiuBox .el-select {
  width: 100%;
}
.yzmBtn{
  border: 1px solid #C2E7B0;
  border-radius: 3px;
  line-height: 26px;
  background: #F0F9EB;
  color: #67C23A;
  font-size: 12px;
}

</style>




// WEBPACK FOOTER //
// src/view/ywbl/tousu/tousujianyi.vue